var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#663300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57449 5.66044L7.27762 3.9375L12.0937 3.95494C12.7969 4.00781 13.6406 4.00781 14.1154 4.60575C14.6779 5.256 14.5547 6.1875 14.2734 6.9255C14.0024 7.71973 13.5319 8.43104 12.907 8.99127C12.2822 9.5515 11.5239 9.94188 10.7049 10.125C9.54506 10.3011 8.36718 10.2482 7.18931 10.2482C7.42387 9.67613 7.65843 9.10181 7.89243 8.52525C8.85937 8.52525 9.84374 8.57812 10.8281 8.42006C11.7247 8.19169 12.5511 7.29506 12.4104 6.31069C12.3221 5.88881 11.8479 5.69531 11.4429 5.69531C9.82631 5.625 8.20856 5.69531 6.59193 5.65988L6.57449 5.66044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.13452H10.2127L9.45731 8.08583H3.726L4.5 6.15196V6.13452ZM5.41406 8.52515H7.40025L5.32688 13.7986H3.375L5.4315 8.52515H5.41406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayx);
export default __webpack_public_path__ + "static/media/payx.4c19386191d00b6c3859f079ee1ca173.svg";
export { ForwardRef as ReactComponent };